import { Check, Loader2 } from 'lucide-react';
import { cn } from '../../utils/helpers';
import { useTranslation } from '../../hooks/useTranslation';

interface SaveBarProps {
  saving?: boolean;
  saved?: boolean;
  /** Optional inline status text ("All changes saved"). */
  message?: string;
  className?: string;
}

/**
 * A lightweight, non-blocking status line for auto-saved settings. Most settings
 * pages persist on change, so this just reflects state rather than gating a form.
 */
export default function SaveBar({ saving, saved, message, className }: SaveBarProps) {
  const { t } = useTranslation();
  if (!saving && !saved && !message) return null;
  return (
    <div className={cn('flex items-center gap-2 text-sm', className)}>
      {saving ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin text-neutral-400 dark:text-neutral-500" />
          <span className="text-neutral-500 dark:text-neutral-400">{t('common.saving')}</span>
        </>
      ) : saved ? (
        <>
          <Check className="w-4 h-4 text-green-600 dark:text-green-500" />
          <span className="text-neutral-500 dark:text-neutral-400">{message ?? t('common.allChangesSaved')}</span>
        </>
      ) : (
        <span className="text-neutral-500 dark:text-neutral-400">{message}</span>
      )}
    </div>
  );
}
